export default "__VITE_ASSET__DpitBFUc__"